import { defineEntity, custom } from './_helpers.js';

export default defineEntity('role', {
    assigned:              custom({ scope: 'access' }),
    unassigned:            custom({ scope: 'access' }),
    permissionsChanged:    custom({ scope: 'access' }),
    'membership.changed':  custom({ scope: 'state' }),
});
